import { useQuery } from '@tanstack/react-query';
import { categoryService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useIconsSummary = () => {
  return useQuery({
    queryKey: queryKey.iconsSummary(),
    queryFn: () => categoryService.getIconsSummary(),
  });
};
